import { postApiGalaxyServer, getApiGalaxyServer, putApiGalaxyServer } from 'services';
import {
  DeleteRealmPayload,
  CreateRealmParams,
  GenerateRealmIdParams,
  FetchAvailableDumpFilesPayload,
} from 'SandboxModule/types';

/* --------------------------- Samples --------------------------- */
export const fetchSandboxes = (
  params: Record<string, never>, // Omit<FetchSandboxParams, "isoStateId">,
  config = {},
  token: string,
) => {
  return getApiGalaxyServer(`/realm/all`, config, token);
};

export const createRealm = ({ params, token, config }: BaseApiParams<CreateRealmParams>) => {
  return postApiGalaxyServer(
    '/realm/createRealm',
    { ...params, meta: params.metaPayload },
    config,
    token,
  );
};

export const deleteRealm = ({ config = {}, params, token }: BaseApiParams<DeleteRealmPayload>) =>
  postApiGalaxyServer('/realm/destroyRealm', params, config, token);

export const getAvailableDumpFiles = ({
  config = {},
  params,
  token,
}: BaseApiParams<FetchAvailableDumpFilesPayload>) =>
  postApiGalaxyServer('/realm/getAvailableDumpFiles', params, config, token);

export const createDumpFile = (params = {}, data = {}, config = {}, token?: string) =>
  postApiGalaxyServer(`/database/createDumpFile`, data, config, token);

export const generateRealmId = ({
  params,
  token,
  config,
}: BaseApiParams<GenerateRealmIdParams>) => {
  return getApiGalaxyServer(`/realm/generateRealmId`, config, token);
};

export const initializeSandbox = (params = {}, data = {}, config = {}, token?: string) =>
  postApiGalaxyServer(`/realm/initializeSandbox`, data, config, token);

export const getSandboxMembersCsvUrl = (params = {}, body = {}, config = {}, token?: string) =>
  postApiGalaxyServer(`/rails_api/sandbox/csv_export_sandbox_members`, body, config, token);

export const updateSandbox = (params = {}, data = {}, config = {}, token?: string) =>
  putApiGalaxyServer(`/realm/updatesandbox`, data, config, token);

export const initAggregateInfra = (data = {}, token?: string) =>
  postApiGalaxyServer(`/realm/backFillAggregateResourcesForRealm`, data, {}, token);

export const destroyAggregateInfra = (data = {}, token?: string) =>
  postApiGalaxyServer(`/realm/cleanUpAggregateResourcesForRealm`, data, {}, token);

export const getSandboxCreators = (params = {}, config = {}, token?: string) =>
  getApiGalaxyServer(`/realm/listCreators`, config, token);
